import dropdown from '~/components/Organisms/Organic/Dropdown/Dropdown.vue'
import hotIcon from '~/components/Molecules/Icon/Icon.vue'
import headerBarMenu from '~/components/Organisms/Organic/HeaderBarMenu/HeaderBarMenu.vue'
import footerBarMenu from '~/components/Organisms/Organic/FooterBarMenu/FooterBarMenu.vue'

export default {
  components: {
    dropdown,
    hotIcon,
    headerBarMenu,
    footerBarMenu,
  },

  props: {
    navigation: {
      type: Array,
      required: false,
    },

    plattaform: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      openSubMenus: [],
    }
  },

  computed: {
    dropdownOpen() {
      return this.openSubMenus.length > 0
    },
  },

  methods: {
    isAnchor(href) {
      return /^(https?:\/\/|\/\/)/.test(href) && /#[\w-]+/.test(href)
    },

    isOpen(index) {
      return this.openSubMenus.includes(index)
    },

    isActive(index) {
      return this.openSubMenus.some(i => i === index)
    },

    toggleDropdown(index) {
      if (this.isOpen(index)) {
        this.openSubMenus = []
        this.$emit('dropdown-open', false)
      } else {
        this.openSubMenus = [index]
        this.$emit('dropdown-open', true)
      }
    },

    handleClose() {
      this.openSubMenus = []
      this.$emit('dropdown-open', false)
    },

    close() {
      this.openSubMenus = []
      this.$emit('dropdown-open', false)
      this.$emit('menu-open', false)
    },

    back() {
      this.close()
    },
  },
}
